import { MglAnlage } from './MglAnlage';

/**
 * APIL Url: /Help/ResourceModel?modelName=MitgliedschaftAnlageProfiWerber
 */
export class MglAnlageProfiWerber extends MglAnlage {

	private profiwerbernummer: string;
	/**
	 * Description: Nummer des Agentur/Handelsvertreter
	 * APIL Type: string
	 */
	get Profiwerbernummer(): string {
		return this.profiwerbernummer;
	}

	/**
	 * Description: Nummer des Agentur/Handelsvertreter
	 * APIL Type: string
	 */
	set Profiwerbernummer(value: string) {
		this.profiwerbernummer = value;
	}

	private pruefziffer: number;
	/**
	 * Description: Prüfziffer bei Messewerber
	 * APIL Type: integer
	 */
	get Pruefziffer(): number {
		return this.pruefziffer;
	}

	/**
	 * Description: Prüfziffer bei Messewerber
	 * APIL Type: integer
	 */
	set Pruefziffer(value: number) {
		this.pruefziffer = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MglAnlageProfiWerber {
		return MglAnlage.createFromObject(dataObject) as MglAnlageProfiWerber;
	}

	public toRequestObject(): { [key: string]: any } {
		const result = super.toRequestObject();
		result.Profiwerbernummer = this.profiwerbernummer;
		result.Pruefziffer = this.pruefziffer;
		return result;
	}

}